const SomethingWentWrong = () => {
	return (
		<>
			<div>Error, reload</div>
		</>
	);
};
export default SomethingWentWrong;
